import { SlidesManager } from "../../providers/slides-manager";
import { smoothScroller } from "../../providers/smooth-scroller";

export const observeScrollOutOfView = (
  target: HTMLElement,
  onScrollOut: () => Promise<void> | void,
) => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio <= 0.01) {
        onScrollOut();
        observer.disconnect();
      }
    },
    { threshold: [0, 0.01] },
  );

  observer.observe(target);
};

const observeScrollIntoView = (
  target: HTMLElement,
  onScrollIntoView: () => void,
) => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.intersectionRatio >= 0.99) {
        onScrollIntoView();
        observer.disconnect();
      }
    },
    { threshold: [0.99] },
  );

  observer.observe(target);
};

export const scrollToNextSlide = (currentSlide: HTMLElement | null) => {
  const { promise, resolve } = Promise.withResolvers<void>();
  const nextElement = currentSlide?.nextElementSibling as HTMLElement;
  const nextSlide = nextElement?.dataset.slide ? nextElement : null;

  if (!currentSlide || !nextSlide) {
    console.debug("No next slide found for: ", currentSlide);
    resolve();

    return promise;
  }

  observeScrollOutOfView(currentSlide, resolve);

  console.debug("go to next slide: ", nextSlide?.dataset.slide);

  smoothScroller.scrollTo(nextSlide);

  return promise;
};

export const scrollToPreviousSlide = (currentSlide: HTMLElement | null) => {
  const { promise, resolve } = Promise.withResolvers<void>();
  const previousElement = currentSlide?.previousElementSibling as HTMLElement;
  const previousSlide = previousElement?.dataset.slide ? previousElement : null;

  if (!currentSlide || !previousSlide) {
    console.debug("No previous slide found for: ", currentSlide);
    resolve(undefined);

    return promise;
  }

  observeScrollOutOfView(currentSlide, resolve);

  console.debug("go to previous slide: ", previousSlide.dataset.slide);

  smoothScroller.scrollTo(previousSlide);

  return promise;
};

export const scrollToTop = () => {
  const mainSlide = SlidesManager.getSlide("main");

  if (!mainSlide) {
    return;
  }

  mainSlide.goToCTAState?.();
  SlidesManager.isScrollingThrough = true;
  observeScrollIntoView(mainSlide.slideNode, () => {
    SlidesManager.isScrollingThrough = false;
  });

  smoothScroller.scrollTo(mainSlide.slideNode);
};
